/**
 * Category Select Handler
 *
 * Handles navigation when a user changes the Financial Help category
 * dropdown on mobile/narrow viewports.
 */

export function initCategorySelect() {
	document.addEventListener('change', function (event) {
		const select = event.target.closest('[data-financial-help-category-select]');

		if (!select || !select.value) {
			return;
		}

		window.location.href = select.value;
	});
}
